import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { Children, cloneElement, isValidElement, useState } from 'react';
import classNames from 'classnames';
import useMeasure from 'react-use-measure';
import { useSelect } from './select';
import styles from './styles.module.scss';
import { BottomSheet } from '../../../../shared/engage/components/bottom-sheet/bottom-sheet';
import { Button } from '../button/button';
import { TextS } from '../typography/typography';
import { useBreakpoints } from '../../hooks/use-get-breakpoints';
import { useDropdownPosition } from '../../hooks/use-dropdown-position';
export var SelectContent = function (_a) {
    var children = _a.children, title = _a.title, subtitle = _a.subtitle, _b = _a.confirmButtonText, confirmButtonText = _b === void 0 ? 'Select' : _b, _c = _a.localSelectErrorMessage, localSelectErrorMessage = _c === void 0 ? 'Please select an option' : _c, className = _a.className, automationId = _a.automationId;
    var _d = useMeasure(), contentRef = _d[0], contentBounds = _d[1];
    var _e = useSelect(), isOpen = _e.isOpen, toggleSelect = _e.toggleSelect, triggerRef = _e.triggerRef;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var _f = useState(), temporarySelectedValue = _f[0], setTemporarySelectedOption = _f[1];
    var _g = useState(''), localSelectError = _g[0], setLocalSelectError = _g[1];
    var dropdownPosition = useDropdownPosition(isOpen, triggerRef.current, contentBounds, 'bottom', 'start', 'force-bottom');
    var handleClose = function () {
        toggleSelect();
        setLocalSelectError('');
        setTemporarySelectedOption(undefined);
    };
    var injectPropsToChildren = function () {
        var correctChildren = typeof children === 'function' ? children({ tempValue: temporarySelectedValue }).props.children : children;
        var childrenArray = Children.toArray(correctChildren);
        return Children.map(childrenArray, function (child, index) {
            if (!isValidElement(child))
                return child;
            var option = child;
            var originalOnClick = option.props.onClick;
            var isLastOption = index === childrenArray.length - 1;
            var directClickHandler = function (value) {
                setTemporarySelectedOption(value);
                if (!isMobileOrSmaller) {
                    if (originalOnClick)
                        originalOnClick(value);
                    handleClose();
                }
            };
            return cloneElement(option, {
                isLastOption: isLastOption,
                onClick: directClickHandler,
                automationId: automationId,
            });
        });
    };
    var handleConfirmSelection = function () {
        var _a, _b;
        if (!temporarySelectedValue) {
            setLocalSelectError(localSelectErrorMessage);
            return;
        }
        var correctChildren = typeof children === 'function' ? children({ tempValue: temporarySelectedValue }).props.children : children;
        var childrenArray = Children.toArray(correctChildren);
        var selectedChild = childrenArray.find(function (child) { return isValidElement(child) && child.props.value === temporarySelectedValue; });
        (_b = selectedChild === null || selectedChild === void 0 ? void 0 : (_a = selectedChild.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, temporarySelectedValue);
        handleClose();
    };
    var childrenWithProps = injectPropsToChildren();
    if (isMobileOrSmaller) {
        return (_jsxs(BottomSheet, { open: isOpen, onClose: handleClose, title: title, children: [_jsxs(BottomSheet.Subtitle, { children: [subtitle && _jsx(TextS, { color: "secondary", children: subtitle }), localSelectError && _jsx(TextS, { color: "negative", children: localSelectError })] }), _jsx(BottomSheet.Content, { children: childrenWithProps }), _jsx(BottomSheet.Actions, { children: _jsx(Button, { fullWidth: true, onClick: handleConfirmSelection, children: confirmButtonText }) })] }));
    }
    if (!triggerRef.current || !dropdownPosition) {
        return null;
    }
    return createPortal(_jsx("div", { ref: contentRef, className: classNames(styles.content, className), style: dropdownPosition, "data-select-content": true, "data-automation-id": "container:select:".concat(automationId), children: childrenWithProps }), document.getElementById('app-modals-portal'));
};
